/** @jsxImportSource @emotion/react */

import { getWatermarkPreviewImg } from "../../utils/watermarkHelpers";

import { previewContainer, previewImage, floatWatermark } from "./styles";

interface Props {
  type: string;
  position: string;
  watermarkUrl: string;
}

const WatermarkPreviewBlock = ({ type, position, watermarkUrl }: Props): JSX.Element => (
  <div css={previewContainer}>
    <img
      css={previewImage}
      src={getWatermarkPreviewImg({
        watermarkUrl,
        type,
        position,
      })}
      alt="watermark preview"
    />
    {watermarkUrl && <div css={floatWatermark(position, watermarkUrl)} />}
  </div>
);
export default WatermarkPreviewBlock;
